import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-full border-r overflow-y-scroll" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sub_menu = _resolveComponent("sub-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_sub_menu, {
      links: _ctx.links,
      header: "Employment Law"
    }, null, 8, ["links"]),
    _createVNode(_component_sub_menu, {
      links: _ctx.settlementLinks,
      header: "Settlement Agreement"
    }, null, 8, ["links"])
  ]))
}